import { lockBody, unlockBody } from "@plugins";

class SidebarConnection {
    constructor(element) {
        this.element = element;
        this.openerTrigger = this.element.querySelector(".js-sidebar-connection-open");
        this.closerTrigger = this.element.querySelector(".js-sidebar-connection-close");
        this.blackout = this.element.querySelector(".js-sidebar-connection-blackout");

        this._init();
    }

    _init() {
        this._initTriggers();

        if (this.tooltips) {
            this._initTooltips();
        }
    }

    _initBlackout() {
        this.blackout.addEventListener("click", () => {
            this._close();
        });
    }

    _initTriggers() {
        if (this.openerTrigger) {
            this.openerTrigger.classList.add("active");
            this.openerTrigger.addEventListener("click", () => {
                this._open();
            });
        }

        if (this.closerTrigger) {
            this.closerTrigger.addEventListener("click", () => {
                this._close();
            });
        }
    }

    _open() {
        if (window.mobileMedia) {
            lockBody(document.body);
            this._initBlackout();
        }

        this.openerTrigger.classList.remove("active");
        this.closerTrigger.classList.add("active");
        this.element.classList.add("active");
    }

    _close() {
        if (window.mobileMedia) {
            unlockBody(document.body);
        }

        this.closerTrigger.classList.remove("active");
        this.openerTrigger.classList.add("active");
        this.element.classList.remove("active");
    }
}

const sidebarConnection = document.querySelector(".js-sidebar-connection-init");

if (sidebarConnection) {
    window.addEventListener("load", () => new SidebarConnection(sidebarConnection));
}
